import { render, staticRenderFns } from "./OthersBottom.vue?vue&type=template&id=47a914b7&scoped=true&"
import script from "./OthersBottom.vue?vue&type=script&lang=js&"
export * from "./OthersBottom.vue?vue&type=script&lang=js&"
import style0 from "./OthersBottom.vue?vue&type=style&index=0&id=47a914b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a914b7",
  null
  
)

export default component.exports